import ProgressStepper from "../../../components/ProgressStepper";

export interface KycStepperProps {
  steps: string[];
  activeIndex: number;
}

const KycStepper = ({ steps, activeIndex }: KycStepperProps): JSX.Element => (
  <ProgressStepper steps={steps} activeStep={activeIndex} />
);

export default KycStepper;
